import React, { useEffect, useState, useRef } from "react"
import FullTable from "components/shared/FullTable"
import { useMainIngestMutation, useMainPatchMutation, useMainRetrieveQuery } from "services/api"
import { Formik, Form, Field, ErrorMessage } from "formik"
import helpers from "helpers"
import FormError from "components/shared/FormError"
import Select from "components/Select"
import DeleteUndoButton from "./DeleteUndoButton"
import * as Yup from "yup"
import { toast } from "react-toastify"
import Modal from "react-responsive-modal"
import _ from "lodash"

function Developers() {
	const q = useMainRetrieveQuery({ action: "getDevelopers", tags: ["developers"] })
	const [create, createData] = useMainIngestMutation()
	const [patch, patchData] = useMainPatchMutation()
	const [developers, setDevelopers] = useState([])
	const [editData, setEditData] = useState(null)
	const [editModal, setEditModal] = useState(false)
	const [confirmDelete, setConfirmDelete] = useState(false)
	let model = {
		name: "",
		url: "",
	}
	useEffect(() => {
		if (q.data) {
			setDevelopers(buildRows(q.data))
		}
	}, [q])

	const normalizeName = (value) => String(value ?? "").trim()
	const nameCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" })

	const buildRows = (data) => {
		let ret = []
		_.forEach(data, (item) => {
			ret.push({
				...item,
				name: item.name,
				edit: (
					<i
						className="fa-solid fa-pen-field cursor-pointer text-primary"
						onClick={() => {
							setEditData(item)
							setEditModal(true)
						}}></i>
				),
			})
		})

		return ret
	}

	const validation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
		})
	}

	const columns = [
		{
			id: "id",
			header: "ID",
		},
		{
			id: "name",
			header: "Name",
			accessorFn: (row) => normalizeName(row.name),
			sortingFn: (rowA, rowB, columnId) =>
				nameCollator.compare(rowA.getValue(columnId), rowB.getValue(columnId)),
			cell: (info) => (
				<span
					className="cursor-pointer"
					onClick={() => {
						setEditData(info.row.original)
						setEditModal(true)
					}}>
					{info.row.original.name}
				</span>
			),
		},
		{
			id: "url",
			header: "URL",
		},
		{
			id: "edit",
			header: "Edit",
			filterable: false,
		},
	]

	const DisplayForm = (props) => {
		let init = _.clone(model)
		if (editData && !props?.new) init = editData
		return (
			<Formik
				initialValues={init}
				validationSchema={validation}
				onSubmit={async (values, { resetForm, setSubmitting }) => {
					let resp
					if (props?.new) {
						resp = await create({ ...values, action: "createDeveloper", tags: ["developers"] })
					} else {
						resp = await patch({
							...values,
							type: "developers",
							action: "updateResource",
							tags: ["developers"],
						})
					}
					if (resp.data?.status === 200) {
						toast.success(resp.data.message)
						resetForm()
						setEditData(null)
						setEditModal(false)
					} else if (resp.data?.status === 400) {
						toast.error("Error creating user.")
					}
					setSubmitting(false)
				}}>
				{(f) => (
					<>
						<Form>
							{/* console.log(f.values) */}
							<ul className="formList">
								<li className={helpers.formField(f, "name")}>
									<ErrorMessage name="name" component={FormError} />
									<label>Name</label>
									<Field type="text" name="name" />
								</li>
								<li className={helpers.formField(f, "url")}>
									<ErrorMessage name="url" component={FormError} />
									<label>URL</label>
									<Field type="text" name="url" />
								</li>
							</ul>
							<button type="submit" disabled={f.isSubmitting} className="mt-12">
								Submit
							</button>
						</Form>
					</>
				)}
			</Formik>
		)
	}

	return (
		<div className="">
			<div className="group">
				<h2>Add Developer</h2>
				<DisplayForm new={true} />
			</div>
			<div className="flex justify-between items-center mt-12">
				<h2 className="!m-0">Current Developers</h2>
				<DeleteUndoButton />
			</div>
			<FullTable data={developers} columns={columns} admin={true} />
			<Modal
				open={editModal}
				onClose={() => {
					setEditModal(false)
					setConfirmDelete(false)
				}}
				center>
				<h2>Edit Developers</h2>
				<div className="flex justify-end">
					<span
						className="btn !bg-red-500 !text-xs ml-5"
						onClick={async () => {
							if (!confirmDelete) {
								setConfirmDelete(true)
							} else {
								let resp = await patch({
									id: editData.id,
									action: "deleteDeveloper",
									tags: ["developers", "deleteUndo"],
								})
								const message = resp?.data?.message
								const messageText = typeof message === "object" ? message?.text : message
								if (resp?.data?.status === 200 && !messageText?.includes("cannot be deleted")) {
									toast.success(messageText)
									setEditModal(false)
									setEditData(null)
								} else {
									toast.error(messageText || "Unable to delete developer.")
								}
								setConfirmDelete(false)
							}
						}}>
						{confirmDelete ? "Confirm Delete?" : "Delete Developer"}
					</span>
				</div>
				<DisplayForm />
			</Modal>
		</div>
	)
}

export default Developers
